import React from 'react';

const AccountDeletionPage = () => {
  const sendMail = () => {
    const email = "support@getbentobox.in";
    const subject = encodeURIComponent("Account Deletion Request");
    const body = encodeURIComponent(
      `I want to delete my account from BentoBox.\n\nMy account details are:\nName: [Your Name]\nPhone Number: [Your Phone Number]`
    );
    
    window.location.href = `mailto:${email}?subject=${subject}&body=${body}`;
  };

  return (
    <div className="!pt-28 md:!pt-32 flex flex-col items-center justify-center p-6">
      <div className="bg-white rounded-lg shadow-2xl max-w-lg w-full text-center overflow-hidden">
        
        {/* Header Section */}
        <div className="bg-gray-800 p-8">
          <h1 className="text-2xl sm:text-3xl font-bold text-white mb-2">
            Account Deletion
          </h1>
          <p className="text-gray-300 text-sm sm:text-base">
            This action is irreversible. Please proceed with caution.
          </p>
        </div>
        
        {/* Content Section */}
        <div className="p-8">
          {/* Instructions */}
          <p className="text-gray-700 mb-6">
            To finalize your account deletion, click the button below to send a confirmation email from your registered address.
          </p>
          
          {/* Button */}
          <button
            onClick={sendMail}
            className="w-full px-6 py-4 bg-red-600 text-white font-semibold text-lg rounded-md hover:bg-red-700 transform hover:scale-105 focus:outline-none focus:ring-4 focus:ring-red-500 focus:ring-opacity-50 transition-transform duration-200"
          >
            Send Deletion Email
          </button>
          
          {/* Disclaimer Note */}
          <div className="mt-8 text-sm text-gray-500">
            <p>
              It may take <span className="font-semibold">5-7 business days</span> to process your request and remove your data from our systems.
            </p>
          </div>
        </div>
        
      </div>
    </div>
  );
};

export default AccountDeletionPage;